import React, { useRef, useState } from 'react';
import TurnstileField, { widgetErrorMessage } from './TurnstileField';

export default function ContactModal({ onClose, subject }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  const [turnstileError, setTurnstileError] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const turnstileRef = useRef(null);

  async function submit(event) {
    event.preventDefault();
    setStatus(null);

    if (!turnstileToken) {
      setStatus({ ok: false, msg: 'Please complete the verification.' });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
          subject,
          turnstileToken
        })
      });

      const data = await response.json();
      if (response.ok) {
        setStatus({ ok: true, msg: 'Message sent. We will contact you shortly.' });
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
        setTurnstileToken('');
        setTurnstileError('');
        turnstileRef.current?.reset?.();
      } else {
        setStatus({ ok: false, msg: data.error || data.message || 'Failed to send message.' });
        turnstileRef.current?.reset?.();
        setTurnstileToken('');
      }
    } catch (error) {
      setStatus({ ok: false, msg: error.message || 'Failed to send message.' });
      turnstileRef.current?.reset?.();
      setTurnstileToken('');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal card">
        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3>Contact Us</h3>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 0, fontSize: 16, cursor: 'pointer', color: '#24364a' }}
            aria-label="Close contact form"
          >
            Close
          </button>
        </header>

        <form onSubmit={submit} className="modal-form">
          <div className="modal-intro">
            <p>Tell us what you need help with and we will get back to you shortly.</p>
          </div>

          <input required placeholder="Your name" value={name} onChange={(event) => setName(event.target.value)} />
          <input required placeholder="Email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
          <input placeholder="Phone (optional)" value={phone} onChange={(event) => setPhone(event.target.value)} />
          <textarea required placeholder="Message" rows="5" value={message} onChange={(event) => setMessage(event.target.value)} />

          <TurnstileField
            ref={turnstileRef}
            onVerify={(token) => {
              setTurnstileToken(token);
              setTurnstileError('');
            }}
            onExpire={() => {
              setTurnstileToken('');
              setTurnstileError('Verification expired. Please complete it again.');
            }}
            onError={() => {
              setTurnstileToken('');
              setTurnstileError(widgetErrorMessage);
            }}
            errorMessage={turnstileError}
          />

          {status && (
            <div className={`modal-status ${status.ok ? 'is-success' : 'is-error'}`}>
              {status.msg}
            </div>
          )}

          <div className="modal-actions">
            <button type="button" className="btn btn-outline-accent" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button className="btn" type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(7, 17, 29, 0.72);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          z-index: 1000;
        }

        .modal.card {
          width: 100%;
          max-width: 680px;
          padding: 24px;
          border-radius: 28px;
          background: #ffffff;
          box-shadow: 0 24px 60px rgba(7, 17, 29, 0.28);
        }
      `}</style>
    </div>
  );
}
